import { ButtonProps, Button } from "@mui/material";
import { useFormikContext } from "formik";

export default function FormikSubmitButton(props: ButtonProps) {
  const { isSubmitting } = useFormikContext();
  return <Button type="submit" disabled={isSubmitting} {...props} />;
}
